import * as tslib_1 from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
var List = function (_a) {
    var ordered = _a.ordered, items = _a.items, mergedStyles = _a.mergedStyles, textDirection = _a.textDirection, blockProps = _a.blockProps, getBlockStyleClasses = _a.getBlockStyleClasses, blockDataToStyle = _a.blockDataToStyle;
    var Component = ordered ? 'ol' : 'ul';
    var listType = ordered ? 'ordered' : 'unordered';
    var containerClassName = mergedStyles[listType + "ListContainer"];
    return (React.createElement(Component, { className: containerClassName }, items.map(function (children, i) {
        // NOTE: list block data is an array of data entries per list item
        var dataEntry = blockProps.data.length > i ? blockProps.data[i] : {};
        var paragraphGroup = [];
        var result = [];
        var elementProps = function (key) { return ({
            className: mergedStyles.elementSpacing,
            key: key,
        }); };
        React.Children.forEach(children, function (child, a) {
            if (child) {
                if (/h\d/.exec(child.type)) {
                    if (paragraphGroup.length) {
                        result.push(React.createElement("div", tslib_1.__assign({}, elementProps(a)), paragraphGroup));
                        paragraphGroup = [];
                    }
                    result.push(React.cloneElement(child, elementProps(a)));
                }
                else {
                    paragraphGroup.push(child);
                }
            }
        });
        if (paragraphGroup.length) {
            result.push(React.createElement("div", tslib_1.__assign({}, elementProps('just_some_key')), paragraphGroup));
        }
        return (React.createElement("li", { className: getBlockStyleClasses(dataEntry, mergedStyles, textDirection, mergedStyles[listType + "List"]), key: blockProps.keys[i], style: blockDataToStyle(blockProps.data[i]) }, result));
    })));
};
List.propTypes = {
    blockDataToStyle: PropTypes.func,
    blockProps: PropTypes.object,
    getBlockStyleClasses: PropTypes.func,
    items: PropTypes.array,
    mergedStyles: PropTypes.object,
    ordered: PropTypes.bool,
    textDirection: PropTypes.oneOf(['rtl', 'ltr']),
};
export default List;
//# sourceMappingURL=List.js.map